<template>
  <div>
    <div class="header-img">
      <img
        :src="proInfo.TitleImagePath !=null?proInfo.TitleImagePath +'?x-oss-process=image/resize,m_fill,h_400,w_750':defaultImg"
        :onerror="defaultImg"
        alt
      >
    </div>
    <div class="intro">
      <h5>{{proInfo.Title}}</h5>
      <div class="label clearfix">
        <span v-for="(tag,i) in splitTags(proInfo.Tags)" :key="i">{{tag}}</span>
      </div>
      <div class="info">商品类别：{{proInfo.Type}}</div>
      <div class="info">提供单位：{{proInfo.Company}}</div>
      <!-- <div class="info">联系方式：{{proInfo.Contact}}</div> -->
    </div>
    <div class="article">
      <h5>商品简介</h5>
      <article v-html="proInfo.Description"></article>
    </div>
    <footer class="clearfix">
      <ul class="menu clearfix">
        <li>
          <router-link :to="{path:'/'}">
            <i></i>
            <span>首页</span>
          </router-link>
        </li>
        <collect :resource-id="$route.params.id" type="goods"/>
        <share-button :share-data="returnInfo"/>
      </ul>
      <button class="btn-main btn-apply" @click="connect()">联系他们</button>
    </footer>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import Utility from '@/helper/util.js'
import Constants from '@/js/constants.js'
import footerLogo from '@/components/footerLogo.vue'
import Collect from '@/components/collect.vue'
import ShareButton from '@/components/shareButton.vue'
export default {
  components: {
    ShareButton,
    Collect,
    'footer-logo': footerLogo
  },
  data() {
    return {
      proData: {
        proId: this.$route.query.id
      },
      returnInfo: {
        title: '',
        desc: '',
        link: location.href,
        image: ''
      },
      Contact: '',
      proInfo: {},

      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },

  created() {
    let productId = this.$route.params.id
    if (!productId) productId = this.$route.query.id
    this.proData.proId = productId
    this.getProInfo()
  },
  methods: {
    splitTags(tags) {
      return Utility.splitTags(tags)
    },
    getProInfo() {
      this.$fetch('/api/Product/GetProDetail', this.proData).then(result => {
        this.proInfo = result
        this.Contact = this.proInfo.Contact
        this.returnInfo.title = result.Title
        this.returnInfo.desc = this.removeHtml(result.Description)
        this.returnInfo.image = result.TitleImagePath

        document.title = result.Title
      })
    },
    connect() {
      this.$dialog.alert({
        mes: this.Contact,
        timeout: 1000
      })
    }
  }
}
</script>

<style lang="less">
.header-img {
  width: 100%;
  height: 360 / @rem-size;
  overflow: hidden;
}

.intro {
  background: #fff;
  padding: 0 24 / @rem-size 25 / @rem-size;
  border-bottom: 20 / @rem-size solid #f7f7f7;

  h5 {
    font-size: 32 / @rem-size;
    color: #333;
    line-height: 45 / @rem-size;
    font-weight: normal;
    margin-top: 15 / @rem-size;
  }

  .label {
    span {
      display: block;
      padding: 8 / @rem-size 18 / @rem-size;
      float: left;
      font-size: 24 / @rem-size;
      color: #999;
      border: 1px solid #e5e5e5;
      border-radius: 5 / @rem-size;
      margin-right: 14 / @rem-size;
      margin-top: 14 / @rem-size;
    }
  }

  .info {
    font-size: 28 / @rem-size;
    color: #999;
    margin-top: 20 / @rem-size;
  }
}

.article {
  padding: 0 0 20 / @rem-size;
  background: #fff;

  article {
    padding: 20 / @rem-size 24 / @rem-size;
    color: #000033;
    font-size: 28 / @rem-size;
    line-height: 40 / @rem-size;
  }

  h5 {
    font-size: 32 / @rem-size;
    color: #000033;
    padding-left: 48 / @rem-size;
    line-height: 72 / @rem-size;
    border-bottom: 1px solid #e5e5e5;
    position: relative;

    &::after {
      display: block;
      content: '';
      width: 4 / @rem-size;
      height: 32 / @rem-size;
      background: #005fd5;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24 / @rem-size;
      margin: auto;
    }
  }
}

footer {
  width: 100%;
  height: 98 / @rem-size;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  box-shadow: 0 0 18px 0 rgba(208, 208, 208, 0.2);
  // display: flex;
  z-index: 888;

  .menu {
    width: 390 / @rem-size;
    height: 100%;
    float: left;

    li {
      width: 33.33333%;
      height: 100%;
      float: left;
      padding-top: 10 / @rem-size;

      &:active {
        opacity: 0.8;
      }

      i {
        display: block;
        width: 46 / @rem-size;
        height: 44 / @rem-size;
        margin: 0 auto;
        background-image: url('../../assets/images/activity-icon.png');
        background-size: 184 / @rem-size 44 / @rem-size;

        &.collected {
          background-position: -92 / @rem-size 0 !important;
        }
      }

      &:nth-child(2) {
        i {
          background-position: -46 / @rem-size 0;
        }
      }

      &:nth-child(3) {
        i {
          background-position: -138 / @rem-size 0;
        }
      }

      span {
        display: block;
        font-size: 24 / @rem-size;
        color: #999;
        text-align: center;
        margin-top: 8 / @rem-size;
      }
    }
  }
}

.btn-apply {
  width: 360 / @rem-size;
  height: 100%;
  float: left;
  font-size: 36 / @rem-size;
  box-shadow: unset;
}
</style>
